import { motion } from "framer-motion";
import '../../Styles/Admin/StatCard.css'; 
import React from "react";

const StatCard = ({ name, icon: Icon, value, color }) => {
    return (
        <motion.div
            className="stat-card"
            whileHover={{ 
                y: -5, 
                boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)" 
            }}
        >
            <div className="stat-card__content">
                <span className="stat-card__title">
                    <Icon 
                        size={20} 
                        className="stat-card__icon" 
                        style={{ color }} 
                    />
                    {name}
                </span>
                <p className="stat-card__value">{value}</p>
            </div>
        </motion.div>
    );
};

export default StatCard;
